import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExcelUploadComponent } from './excel-upload/excel-upload.component';
import { AuthGuardService as AuthGuard } from './../../auth-guard.service';
const routes: Routes = [
  {
    path:'excelqanda',
    component:ExcelUploadComponent,
    canActivate: [AuthGuard], 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExcelqueandansRoutingModule { }
